import { render, staticRenderFns } from "./OfficerOpenRecruitmentManagerShow.vue?vue&type=template&id=d0104530&"
import script from "./OfficerOpenRecruitmentManagerShow.vue?vue&type=script&lang=js&"
export * from "./OfficerOpenRecruitmentManagerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports